export const GROUPS_BLOCK = 'groups_block';
export const SIMPLE_GROUP = 'simple_group';
export const PHOTO_GROUP = 'photo_group';
export const COLOR_GROUP = 'color_group';

export const BASE_STYLES = 'base_styles';

export const control_options = [{
	label: 'Общий шаблон',
	value: GROUPS_BLOCK,
},{
	label: 'Группа (список)',
	value: SIMPLE_GROUP,
},{
	label: 'Группа (фото)',
	value: PHOTO_GROUP,
},{
	label: 'Группа (цвет)',
	value: COLOR_GROUP,
},{
	label: 'Стили',
	value: BASE_STYLES,
},];